import gallery from "../components/gallerySplide";

gallery();
